<template>
  <div class="full-right-user">
    <div class="full-right-user-img">
      <!-- <img src="~@/assets/images/avatar_default.png" /> -->
      <img
        src="http://safety-education-file.oss-cn-shenzhen.aliyuncs.com/schoolFaceFile/76b1a1b1445a49438661f07f30d4146a.png?x-oss-process=style/compression"
      />
    </div>
    <div class="full-right-user-text">
      <span>王文华</span>
      <i>48小时</i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      title: "",
    };
  },
  mounted() {},
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.full-right-user {
  margin-bottom: 20px;
  float: left;
  width: 25%;
  .full-right-user-img {
    width: 40px;
    height: 40px;
    line-height: 0;
    text-align: center;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
      box-shadow: 0 0 5px #fff;
    }
  }
  .full-right-user-text {
    color: #ff0000;
    font-size: 12px;
    text-align: center;
    padding-top: 10px;
    line-height: 18px;
    span {
      display: block;
    }
    i {
      display: block;
      font-style: normal;
    }
  }
}
</style>
